
import * as OSS from "ali-oss";
import { getCipherText } from "../../../service/upload"
import { ElMessage } from 'element-plus'
import { Base64UTF } from "./base64UTF";
import privateCapabilities from '@cttq/private-capabilities-v3';
const globalStateAll = privateCapabilities.userGlobalState()
const globalState = globalStateAll.state

// 获取人员工号
function getPersonCode(){
  return globalState.userInfo.personCode;
}
// 设置回调参数
function setCallbackVarParams(fileName, response,apiParams) {
  const defaultParams = {
    "x:originalName": fileName,
    "x:accessToken": response.accessToken,
    "x:fileName": fileName,
    "x:appSource": apiParams.appSource || "ui-demo",
    "x:reqSource": "pc",
    "x:personCode": getPersonCode(),
    'x:userCid': getPersonCode(),
    // 'x:fileACL': 'private',
    'x:bucket': response.bucket,
    "x:dir": response.dir,
    "x:remark": "文件上传",
    ...apiParams.setCallbackVarParams,
  };
  const splitList = fileName.split(".");
  const imageType = splitList[splitList.length - 1];
  defaultParams["x:fileType"] = imageType;
  return defaultParams;
}

/**
 * 阿里云OSS上传
 * @param {*} paramsObj
 */
export default function aliOSSUpload(paramsObj) {
  return new Promise((resolve, reject) => {
    const { file, apiParams } = paramsObj;
    getCipherText(apiParams).then(res => {
      let { code, data, msgCode, responseData } = res;
      code = code || msgCode;
      data = data || responseData;
      if (!['100', '200'].includes(String(code))) {
        ElMessage.error("阿里云TOKEN个人权限密钥获取失败,请联系管理员。");
        return;
      }
      // 3. 解构密钥中的信息
      let { callback, credentials, regionId, region, bucketName, bucket, dir, endpoint } = data;
      const { accessKeyId, accessKeySecret, securityToken } = credentials;
      const { callbackUrl, callbackBody, callbackBodyType } = callback;
      regionId = regionId || credentials.regionId;
      region = region || credentials.region;
      bucketName = bucketName || credentials.bucketName;
      bucket = bucket || credentials.bucket;
      dir = dir || credentials.dir;
      endpoint = endpoint || credentials.endPoint;
      // 4. 发起正式阿里云上传请求的准备
      const ossParams = {
        endpoint,
        region: region || "OSS-" + regionId,
        accessKeyId,
        accessKeySecret,
        bucket: bucket || bucketName,
        stsToken: securityToken,
        secure: true
      };
      const clientData = OSS(ossParams); // 实例化OSS
      const overWriteCB = { callbackUrl, callbackBody, callbackBodyType };
      const cbData = setCallbackVarParams(file.name, data, apiParams);
      const storagePath = dir + getPersonCode() + "_" + getTimeStamp() + file.name; 	// 存储方式：目录 + 文件名 + 后缀
      // 4.1 已装载碎片分段请求所需的参数、并发起请求
      clientData.multipartUpload(storagePath, file, {
        headers: {
          // eslint-disable-next-line no-undef
          "x-oss-callback": Base64UTF.encode(JSON.stringify(overWriteCB)),
          // eslint-disable-next-line no-undef
          "x-oss-callback-var": Base64UTF.encode(JSON.stringify(cbData)),
          // "Content-Type": "text/plain; charset=utf-8"
        }
      }).then((results) => {
        resolve(results.data.responseData);
      }).catch((err) => {
        console.log("🚀 ~ getCipherText ~ err:", err)
        ElMessage.error("上传失败了，请重试或联系管理员。");
        reject(err)
      });
    }).catch(err => {
      console.log("🚀 ~ getCipherText ~ err:", err)
      ElMessage.error("文件中心获取token接口失败，请重试！");
      reject(err)
    })
  });
}



// 获取文件名的后缀可选项
export function getSuffixTypeOptions(suffixName) {
  if(Array.isArray(suffixName)){
    return suffixName
  }
  const image = ["jpg", "jpeg", "png", "bmp" ];
  const microsoft = ["docx", "doc", "pptx", "ppt", "xlsx", "xls"];
  const pdf = ["pdf"];
  const txt = ["txt", "text"];
  switch (suffixName) {
    case 'image':
      return image
    case 'microsoft':
      return microsoft
    case 'microsoft-image':
      return [...microsoft,...image]
    case 'microsoft-pdf-txt':
      return [...microsoft,...image,...pdf,...txt]
    default:
      return []
  }
}
// 获取文件上传的accept
export function getAcceptOptions(suffixType){
  // image/jpg, image/jpeg, image/png, image/bmp, .docx, .pptx, .xlsx, .pdf,.txt
  let suffixOptions = getSuffixTypeOptions(suffixType)
  let accept = ""
  suffixOptions.forEach(item => {
    if (["jpg", "jpeg", "png", "bmp"].includes(item)) {
      accept += `image/${item},`
    } else {
      accept += `.${item},`
    }
  })
  return accept
}
// 获取文件名的后缀
export function getFileSuffixType(name) {
  name = name.split("?")[0];
  if (!name) return "";
  const list = name.split(".");
  return list[list.length - 1].toLowerCase();
}

// 获取文件名不带后缀
export function getFileName(name) {
  name = name.split("?")[0];
  if (!name) return "";
  const list = name.split(".");
  list.pop();
  return list.join();
}

// 数字自动补零
function autoCompleteZero(num) {
  return num < 10 ? "0" + num : num;
}
// 获取当前时间戳
function getTimeStamp() {
  var time = new Date();
  var year = time.getFullYear();
  var month = time.getMonth() + 1;
  var day = time.getDate();
  var hour = time.getHours();
  var minutes = time.getMinutes();
  var seconds = time.getSeconds();
  return (
    String(year) + autoCompleteZero(month) + autoCompleteZero(day) + autoCompleteZero(hour) + autoCompleteZero(minutes) + autoCompleteZero(seconds)
  );
}


